
    var riot = require('riot')
    //src: starling/src/tags/node-layout-menu.html
riot.tag2('node-layout-menu',
  '<ul class="floating-menu_list" riot-style="{getStyle()}"> <li class="floating-menu_item {\'floating-menu_item--active\': selected && selected.rowLayout}" onclick="{this.setLayout.bind(this, \'layout-row\')}" data-track="{getTrackingLabel()}" data-track-action="List-Layout" data-track-label="Layout"> <svg class="floating-menu_icon"> <use xlink:href="#list-layout-icon"></use> </svg> <span class="floating-menu_label">List layout</span> </li> <li class="floating-menu_item {\'floating-menu_item--active\': selected && selected.columnLayout}" onclick="{this.setLayout.bind(this, \'layout-col\')}" data-track="{getTrackingLabel()}" data-track-action="Column-Layout" data-track-label="Layout"> <svg class="floating-menu_icon"> <use xlink:href="#column-layout-icon"></use> </svg> <span class="floating-menu_label">Column layout</span> </li> <li class="floating-menu_item {\'floating-menu_item--active\': selected && selected.freehandLayout}" onclick="{this.setLayout.bind(this, \'layout-freehand\')}" data-track="{getTrackingLabel()}" data-track-action="Freehand-Layout" data-track-label="Layout"> <svg class="floating-menu_icon"> <use xlink:href="#freehand-layout-icon"></use> </svg> <span class="floating-menu_label">Freehand layout</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--fixed floating-menu--small floating-menu--hidden" onmouseenter="{handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _util = require('lib/util');

var _store = require('../store');

var _nodesUi = require('lib/nodes-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.canvas = opts.canvas;
this.operation = opts.operation;
this.canvas.nodeLayoutMenuTag = this;
this.isOpen = false;
this.origin = null;

this.summon = function (_ref) {
  var tag = _ref.tag,
      referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  var rect = referenceEl.getBoundingClientRect();
  _this.tag = tag;
  _this.type = null;

  if (tag && tag.instance) {
    if (tag.instance instanceof _store.Node) {
      _this.type = 'node';

      _this.selected = {
        freehandLayout: tag.instance.layoutName === 'layout-freehand',
        columnLayout: tag.instance.layoutName === 'layout-col',
        rowLayout: tag.instance.layoutName === 'layout-row'
      };
    } else if (tag.instance instanceof _store.Link) {
      _this.type = 'link';
    }
  }
  _this.positionToLeft = positionToLeft;
  _this.origin = origin;
  if (_this.fromOrigin('toolbar')) {
    _this.y = rect.bottom;
    _this.x = rect.left;
  } else {
    _this.y = rect.top;
    _this.x = rect.right;
    if (positionToLeft) {
      _this.x = window.innerWidth - rect.left;
    }
  }

  if (positionToLeft) {
    _this.style = 'top: ' + _this.y + 'px; right: ' + _this.x + 'px;';
  } else {
    _this.style = 'top: ' + _this.y + 'px; left: ' + _this.x + 'px;';
  }
  _this.prevNodePositions = [];
  _this.prevLinkAngles = [];

  _this.root.classList.remove('floating-menu--hidden');
  _this.isOpen = true;
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.on('mount', function () {
  $(_this.root).on('mousedown touchstart pointerdown', function (e) {
    e.stopImmediatePropagation();
  });
});

this.hide = function () {
  _this.isOpen = false;
  _this.origin = null;
  _this.selected = null;
  _this.root.classList.add('floating-menu--hidden');
};

this.getStyle = function () {
  return _this.style;
};

this.setLayout = function (layoutName) {
  _this.changelayoutMessages = [];
  _this.root.classList.add('floating-menu--hidden');
  var nodeTags = [];
  if (_this.tag) {
    nodeTags = [_this.tag];
  } else if (_this.canvas.getSelectedNodes().length) {
    nodeTags = _this.canvas.getSelectedNodes().map(function (n) {
      return _this.canvas.nodeTags[n.id];
    });
  }

  for (var _iterator = nodeTags, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref2 = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref2 = _i.value;
    }

    var nodeTag = _ref2;

    if (nodeTag) {
      _this.setLayoutProcess(layoutName, nodeTag);
    }
  }
  _this.operation.batchOperation({
    messages: _this.changelayoutMessages,
    onFailure: function onFailure(err) {
      console.log('setLayout batchOperation failure: ' + err);
    }
  });
  _this.canvas.bulkActionsMenuTag.update();
  _this.canvas.hidePopups();
};

this.setLayoutProcess = function (layoutName, nodeToChangeLayout) {
  var childNodes = nodeToChangeLayout;
  var prevLayoutName = nodeToChangeLayout.layoutName;
  if (layoutName == 'layout-freehand') {
    var preserveLayout = false;
    var node = _store_instance2.default.getNode(nodeToChangeLayout.id);
    var targetNodeIds = node.children().map(function (n) {
      return n.id;
    });
    var _prevNodePositions = _store_instance2.default.getNodePositions(targetNodeIds);

    for (var _iterator2 = node.children(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var _child = _ref3;

      if (_child.x !== 0 || _child.y !== 0) {
        preserveLayout = true;
        break;
      }
    }

    if (!preserveLayout) {
      var px = null,
          py = null;

      var i = 0;
      for (var _iterator3 = node.children(), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray3) {
          if (_i3 >= _iterator3.length) break;
          _ref4 = _iterator3[_i3++];
        } else {
          _i3 = _iterator3.next();
          if (_i3.done) break;
          _ref4 = _i3.value;
        }

        var child = _ref4;

        // slightly skew and spread children from where they were
        var hJitter = i % 2 == 1 && node.getLayoutName() == 'layout-row' ? 10 : 0;
        var vJitter = i % 2 == 1 && node.getLayoutName() == 'layout-col' ? 10 : 0;
        var scale = 1.1;
        var hpad = 10;
        var vpad = 20;
        var dx = (child.absolutePosition.x - node.absolutePosition.x) * scale + hJitter;
        var dy = (child.absolutePosition.y - node.absolutePosition.y) * scale + vJitter;
        if (px === null && py === null) {
          px = dx + 0;
          py = dy + 0;
        }
        child.x = dx - px + hpad;
        child.y = dy - py + vpad;
        i++;
      }

      _this.changelayoutMessages.push(_this.operation.messages.updateNodePositions({
        prevNodePositions: _prevNodePositions,
        prevLinkAngles: [],
        nodePositions: _store_instance2.default.getNodePositions(targetNodeIds),
        linkAngles: [],
        selectedNodes: [nodeToChangeLayout.id]
      }));
    }
  }

  nodeToChangeLayout.instance.setLayoutName(layoutName);
  _this.canvas.nodesTag.update();
  nodeToChangeLayout.updateLayers();
  nodeToChangeLayout.updateTopLevelNeighborsLite();
  (0, _util.refreshFreehandAncestorsOfList)([nodeToChangeLayout.id], _this.canvas, _store_instance2.default);
  _this.canvas.nodeTags[nodeToChangeLayout.id].topLevelParentTag().rediscoverLinkPositions();

  if (nodeToChangeLayout.childNodesTag) {
    var main = nodeToChangeLayout.childNodesTag.refs.main;
    if (main) {
      main.classList.add("loosening");
      setTimeout(function () {
        main.classList.remove('loosening');
      }, 3000);
    }
  }

  var _nui$fixOverlaps = _nodesUi.nui.fixOverlaps({
    nodeTag: nodeToChangeLayout,
    allowedDirections: ['right', 'down']
  }),
      prevNodePositions = _nui$fixOverlaps.prevNodePositions,
      nodePositions = _nui$fixOverlaps.nodePositions;

  if (nodePositions.length) {
    _this.changelayoutMessages.push(self.operation.messages.updateNodePositions({
      prevNodePositions: prevNodePositions,
      nodePositions: nodePositions,
      prevLinkAngles: [],
      linkAngles: []
    }));
  }

  _this.changelayoutMessages.push(_this.operation.messages.setNodeLayoutName({
    nodeUUID: nodeToChangeLayout.id,
    prevLayoutName: prevLayoutName,
    layoutName: layoutName
  }));

  _this.canvas.hidePopups();
  _this.hide();
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};

this.on('updated', _eventTracking2.default.listen(this.root));

this.getTrackingLabel = function () {
  return (0, _util.getTrackingLabel)({ menuName: _this.origin });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-layout-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-layout-menu.html
// module id = 644
// module chunks = 0